export default "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5 4.5V7.5H10.5V19.5H13.5V7.5H19V4.5H5Z\"></path>\n</svg>"